// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"wq-z","breadcrumbForward":"xq-z","breadcrumbBack":"yq-z","selected":"zq-z"};